import { ChatFill, LikeShape, Plus } from '@peacecover/icon';
import { ReactComponent as GradientLikeShapeIcon } from '../../../icons/likeGradientShape.svg';

interface ChatBadgeProps {
  color: 'white' | 'purple';
  type: 'like' | 'comment';
  state: 'default' | 'valued';
  onClick?: () => void;
  count?: number;
  className?: string;
  isLiked?: boolean;
}

const ChatBadge = ({ color, type, state, count, className, onClick, isLiked }: ChatBadgeProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-fit flex items-center justify-center py-[3px] rounded-[40px] min-w-[38px] border-[2px] border-pure-white dark:border-background-dark ${state === 'default' ? 'px-[5px]' : 'pl-[5px] pr-[7px]'} ${color === 'white' ? 'bg-separator1' : 'bg-primary-light dark:bg-primary-dark'} ${className}`}
    >
      {type === 'like' ? (
        isLiked ? (
          <GradientLikeShapeIcon width={14} height={14} />
        ) : (
          <LikeShape
            size={14}
            className={`${color === 'white' ? 'text-text-main-lv4' : 'text-white-opacity-800 dark:text-black-opacity-700'}`}
          />
        )
      ) : (
        <ChatFill
          size={14}
          className={`${color === 'white' ? 'text-text-main-lv4' : 'text-white-opacity-800 dark:text-black-opacity-700'}`}
        />
      )}
      {state === 'default' ? (
        <Plus
          size={10}
          className={`${color === 'white' ? 'text-text-main-lv4' : 'text-white-opacity-800 dark:text-black-opacity-700'}`}
        />
      ) : (
        <p
          className={`text-[11px] leading-[13px] ml-[1px] ${color === 'white' ? 'text-text-main-lv4' : 'text-white-opacity-800 dark:text-black-opacity-700'}`}
        >
          {count ?? 0}
        </p>
      )}
    </button>
  );
};

export default ChatBadge;
